import { VStack } from '@/components/Layout/Stacks'
import { Button } from '@/components/ui/button'
import {
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { mixpanelClient } from '@/lib/analytics/mixpanelClient'
import { useKycContext } from '@/providers/KycProvider'
import { useTranslations } from 'next-intl'

export function IntroStep() {
  const t = useTranslations('account.kyc.dialog')
  const { handleOpenChange, setKycStep } = useKycContext()

  const processSteps = [
    'startVerification',
    'submitForm',
    'scanQRCode',
    'takeSelfie',
    'scanID',
  ]

  const whatYouWillNeedSteps = [
    'governmentID',
    'cameraEnabledDevice',
    'goodLighting',
  ]

  const handleStartVerification = () => {
    mixpanelClient.track('KYC Started')
    setKycStep('kyc')
  }

  return (
    <>
      <DialogHeader>
        <DialogTitle>{t('intro.title')}</DialogTitle>
        <DialogDescription>{t('intro.description')}</DialogDescription>
      </DialogHeader>

      <VStack className="gap-3 text-foreground-bodytext text-sm">
        <VStack className="gap-1">
          <h4 className="font-medium">{t('intro.process.title')}</h4>
          <ol className="pl-1 list-decimal list-inside">
            {processSteps.map((step) => (
              <li key={step}>{t(`intro.process.steps.${step}`)}</li>
            ))}
          </ol>
        </VStack>
        <p>{t('intro.process.description')}</p>

        <VStack className="gap-1">
          <h4 className="font-medium">{t('intro.whatYouWillNeed.title')}</h4>
          <ul className="pl-1 list-disc list-inside">
            {whatYouWillNeedSteps.map((step) => (
              <li key={step}>{t(`intro.whatYouWillNeed.steps.${step}`)}</li>
            ))}
          </ul>
        </VStack>
        <p className="text-muted-foreground">{t('intro.agreeToShareInfo')}</p>
      </VStack>

      <DialogFooter className="pt-4 border-t">
        <Button onClick={() => handleOpenChange(false)}>
          {t('ctas.close')}
        </Button>
        <Button onClick={handleStartVerification} variant="primary">
          {t('ctas.startVerification')}
        </Button>
      </DialogFooter>
    </>
  )
}
